<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>

            </template>
        </navbar>

        <div class="sticky-top text-right">
            <b-button
                    variant="success"
                    class="btn-round"
                    v-if="typePage !== null" @click="storeText">{{$t('saveTitle')}}
            </b-button>
        </div>

        <br>
        <br>
        <b-form-group label="Select Page">
            <b-form-select @change="getTextByType" v-model="typePage">
                <b-form-select-option value="wasiscbd">Was is CBD</b-form-select-option>
                <b-form-select-option value="uberuns">Über uns</b-form-select-option>
                <b-form-select-option value="datenschutzerklärungen">Datenschutzerklärungen</b-form-select-option>
                <b-form-select-option value="agb">AGB</b-form-select-option>
                <b-form-select-option value="faq">FAQ</b-form-select-option>
                <b-form-select-option value="impressum">Impressum</b-form-select-option>
                <b-form-select-option value="vertrauen">Vertrauen in uns</b-form-select-option>
                <b-form-select-option value="qualität">Qualität</b-form-select-option>
                <b-form-select-option value="jobs">Jobs</b-form-select-option>
                <b-form-select-option value="shop">Shop</b-form-select-option>
                <b-form-select-option value="home_about_left">Home about left side text</b-form-select-option>
                <b-form-select-option value="home_about_right">Home about right side text</b-form-select-option>
                <b-form-select-option value="home_quality">Auf Qualität statt Quantität setzen</b-form-select-option>
                <b-form-select-option value="home_delivery">Zustellservice innerhalb der EU</b-form-select-option>
                <b-form-select-option value="home_secure_payment">Bequeme, flexibale und sichere Zahlung
                </b-form-select-option>
                <b-form-select-option value="home_product_range">Unser Sortiment</b-form-select-option>
                <b-form-select-option value="home_cbd_shiping">CBD-Versand in Österreich</b-form-select-option>
                <b-form-select-option value="home_certificate">Analyse-Zertifikat</b-form-select-option>
                <b-form-select-option value="dictionary">marken</b-form-select-option>
                <b-form-select-option value="headshop">Headshop</b-form-select-option>
                <b-form-select-option value="großhandel">großhandel</b-form-select-option>
                <b-form-select-option value="offer">Unsere Angebote</b-form-select-option>
                <b-form-select-option value="cbd_oil">CBD-Öl Wirkung Anwendung</b-form-select-option>
                <b-form-select-option value="cbd_kosmetik">CBD Kosmetik Wirkung</b-form-select-option>
                <b-form-select-option value="home_page_about">CBD Online Shop von Lord of Hanf</b-form-select-option>
                <b-form-select-option value="home_main">Home Meta Title And Meta Description</b-form-select-option>
                <b-form-select-option value="home_blog">Home Blog</b-form-select-option>
            </b-form-select>
        </b-form-group>


        <b-card>

            <!--url-->
            <template v-if="pagesHasUrl.includes(typePage)">
                <b-form-group label="SEO Url">
                    <b-input-group :prepend="getPlaceHolderUrl">
                        <b-form-input v-model="urlText"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </template>

            <!--meta and title-->
            <template v-if="pagesMetaAndTitle.includes(typePage)">
                <b-form-group label="Meta Title">
                    <b-input v-model="titleText"></b-input>
                </b-form-group>
                <b-form-group label="Meta Description">
                    <tinymce id="d5" :other_options="optionsEditorMeta" v-model="metaText"></tinymce>
                </b-form-group>
            </template>

            <b-form-group label="Title" v-if="typePage !== 'home_main'">
                <b-input v-model="header"></b-input>
            </b-form-group>

            <b-form-group label="Top Description Page" v-if="typePage !== 'home_main'">
                <tinymce id="topDesc" :other_options="optionsEditor" v-model="content"></tinymce>
            </b-form-group>

            <!--desktop and mobile-->
            <template v-if="pagesDescriptionDesktopAndMobile.includes(typePage)">
                <b-form-group label="Description at the bottom of the page Desktop">
                    <tinymce id="d3" :other_options="optionsEditor" v-model="desktopText"></tinymce>
                </b-form-group>
                <b-form-group label="Description at the bottom of the page Mobile">
                    <tinymce id="d4" :other_options="optionsEditor" v-model="mobileText"></tinymce>
                </b-form-group>
            </template>


        </b-card>

    </div>
</template>

<script>
    import Navbar from "../../Partials/Navbar";
    import Http from '../../../Services/HttpService/HttpService'
    import Notificaion from '../../../Services/Notification/Nottification'

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                isSubmit: false,
                placeHolderUrl: "https://lordofhanf.com/",
                pagesHasUrl: [
                    'großhandel',
                    'offer',
                    'shop',
                    'headshop',
                    'cbd_oil',
                    'cbd_kosmetik',
                    'wasiscbd',
                    'uberuns',
                    'datenschutzerklärungen',
                    'agb',
                    'faq',
                    'impressum',
                    'vertrauen',
                    'qualität',
                    'jobs',
                ],
                pagesDescriptionDesktopAndMobile: [
                    'großhandel',
                    'offer',
                    'shop',
                    'headshop',
                    'home_page_about',
                ],
                pagesMetaAndTitle: [
                    'home_main',
                    'großhandel',
                    'offer',
                    'headshop',
                    'cbd_oil',
                    'cbd_kosmetik',
                    'wasiscbd',
                    'uberuns',
                    'datenschutzerklärungen',
                    'agb',
                    'faq',
                    'impressum',
                    'vertrauen',
                    'qualität',
                    'jobs',
                    'shop',
                ],
                typePage: null,
                header: null,
                content: null,
                desktopText: null,
                mobileText: null,
                metaText: null,
                titleText: null,
                urlText: null,
                optionsEditor: {
                    height: 300,
                    toolbar: [
                        'formatselect | fontsizeselect | fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat | bootstrap4grid'
                    ]
                },
                optionsEditorMeta: {
                    height: 110,
                    toolbar: [
                        'formatselect | fontsizeselect | fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat | bootstrap4grid'
                    ]
                },
            }
        },
        computed: {
            getPlaceHolderUrl() {
                switch (this.typePage) {
                    case "offer":
                        return this.placeHolderUrl + "shop/";
                    case "headshop":
                        return this.placeHolderUrl + "shop/";
                    default:
                        return this.placeHolderUrl;

                }
            }
        },
        methods: {
            getTextByType() {
                this.$Progress.start();
                this.isSubmit = false;
                Http.get(Http.apiurlV2() + 'setting/text/show/' + this.typePage)
                    .then(response => {
                        this.isSubmit = true;
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            setTimeout(() => {
                                this.header = response.data.data.header;
                                this.content = response.data.data.content;
                                this.desktopText = response.data.data.desktop;
                                this.mobileText = response.data.data.mobile;
                                this.metaText = response.data.data.meta;
                                this.titleText = response.data.data.title;
                                this.urlText = response.data.data.url;
                            }, 1000);


                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })


            },
            storeText() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'setting/text/update', {
                    type: this.typePage,
                    header: this.header,
                    sub_header: this.content,
                    desktop: this.desktopText,
                    mobile: this.mobileText,
                    meta: this.metaText,
                    title: this.titleText,
                    url: this.urlText,
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            Notificaion.success(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        }

    }
</script>

<style scoped>

</style>